import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text } from 'pcln-design-system'
import { User as UserIcon } from 'pcln-icons'
import styled from 'styled-components'
import getByPath from '../../utils/getByPath'

const StyledText = styled(Text)`
  display: flex;
  align-items: center;
  width: 100%;
`

const SignedInNavLink = ({ membershipName, profile = {} }) => {
  const { fields = {}, data = {} } = profile

  const membershipNumber = getByPath(data, fields.memberId) ?? ''
  const firstName = getByPath(data, fields.firstName) ?? ''
  const hasAccountInfo = firstName || (membershipName && membershipNumber)

  return hasAccountInfo ? (
    <StyledText p={3} color='primary'>
      <UserIcon mr={3} />
      <Flex flexDirection='column'>
        {firstName && <Text>Hello, {firstName}</Text>}
        {membershipName && membershipNumber && (
          <Text fontSize={0} color='text.dark'>
            {membershipName?.toUpperCase()}: {membershipNumber}
          </Text>
        )}
      </Flex>
    </StyledText>
  ) : null
}

SignedInNavLink.propTypes = {
  membershipName: PropTypes.string,
  profile: PropTypes.object,
}

export default SignedInNavLink
